import styled from 'styled-components'

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: var(--common-white-main, #fff);
`

export const Container = styled.div`
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  padding: 0 12px 2rem;
  box-sizing: border-box;

  .pageTitle {
    font-size: 1.25rem;
    font-weight: 600;
    margin: 0.25rem 0 0.25rem;
    color: rgba(0, 0, 0, 0.87);
  }

  .pageSubtitle {
    font-size: 0.875rem;
    font-weight: 400;
    margin: 0 0 1rem;
    color: rgba(0, 0, 0, 0.6);
  }
`

export const TitleBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 8px 0 12px;
  gap: 8px;
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
`

export const Title = styled.h1`
  color: var(--text-primary, rgba(0, 0, 0, 0.87));
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
  @media (min-width: 768px) {
    font-size: 1.5rem;
  }
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  gap: 8px;
  @media (max-width: 600px) {
    width: 100%;
    padding: 4px 0 0;
  }
`

export const SortLabel = styled.div`
  color: var(--text-primary, rgba(0, 0, 0, 0.87));
  font-size: 0.875rem;
`

export const SortButtons = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`

export const SortButton = styled.button<{ $active?: boolean }>`
  appearance: none;
  border: 1px solid ${props => props.$active ? 'var(--primary-blue, #0B4598)' : 'var(--divider, #e0e0e0)'};
  color: ${props => props.$active ? 'var(--primary-blue, #0B4598)' : 'var(--text-primary, #333)'};
  background: ${props => props.$active ? 'rgba(11, 69, 152, 0.06)' : 'var(--common-white-main, #fff)'};
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 0.875rem;
  cursor: pointer;
`

export const ListGrid = styled.ul`
  list-style: none;
  padding: 0;
  margin: 12px 0 24px 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 12px;
`

export const ListItem = styled.li`
  margin: 0;
  padding: 0;
`

export const ItemButton = styled.button`
  width: 100%;
  text-align: left;
  background: var(--common-white-main, #fff);
  border: 1px solid var(--divider, #e0e0e0);
  border-radius: 8px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
  margin-bottom: 0;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);

  &:hover {
    border-color: var(--primary-blue, #0B4598);
    box-shadow: 0 2px 6px rgba(0,0,0,0.06);
  }
`

export const ItemIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgba(11, 69, 152, 0.08);
`

export const ItemTexts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`

export const ItemTitle = styled.div`
  color: var(--text-primary, rgba(0, 0, 0, 0.87));
  font-weight: 600;
  font-size: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ItemSubtitle = styled.div`
  color: var(--text-secondary, rgba(0, 0, 0, 0.6));
  font-size: 0.8125rem;
`

export const Chevron = styled.span`
  color: var(--text-secondary, rgba(0, 0, 0, 0.6));
  font-size: 1rem;
`

export const EmptyState = styled.div`
  color: var(--text-secondary, rgba(0, 0, 0, 0.6));
  text-align: center;
  margin: 24px 0;
`

export const Loading = styled.div`
  color: var(--text-secondary, rgba(0, 0, 0, 0.6));
  text-align: center;
  margin: 24px 0;
`

